import React from 'react';
import { Box, Typography } from '@mui/material';
import { IDDisplayBox } from '../../../../Theme/DigitalTwinStyles';

/**
 * Resolves the "<label>: <value>" identifier shown beside the Battery Health
 * tables (e.g. "Bus Number: X"), driven by
 * batteryHealth.tables.LifecycleMetrics.headerIdentifier ({ label, field }).
 * The value is looked up on batteryInfo, then vehicleInfo, then the first
 * loaded row. Returns { label, value }; value is undefined when not found.
 */
export const resolveHeaderIdentifier = ({ headerIdentifier, batteryInfo, vehicleInfo, fallbackRow, defaultLabel } = {}) => {
    const field = headerIdentifier?.field || 'deviceID';
    return {
        label: headerIdentifier?.label || defaultLabel,
        value: batteryInfo?.[field] ?? vehicleInfo?.[field] ?? fallbackRow?.[field],
    };
};

/**
 * The identifier box itself; renders nothing when there is no value.
 * testId: per view, e.g. "battery-health-header-identifier-snapshot".
 */
const HeaderIdentifierBox = ({ label, value, testId = 'battery-health-header-identifier' }) => {
    if (!value) return null;
    return (
        <IDDisplayBox data-testid={testId}>
            <Box>
                <Typography variant="fw400s12c494949">{label}: </Typography>
                <Typography variant="fw400s12c494949">{value}</Typography>
            </Box>
        </IDDisplayBox>
    );
};

export default HeaderIdentifierBox;
